import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type SendIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
}

export const SendIcon = ({
  size = 16,
  color,
  colorScheme = 'dark',
}: SendIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))

  return (
    <svg
      fill='none'
      height={size}
      viewBox='0 0 16 16'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.6667 1.3334L7.3334 8.66672M7.3334 8.66672L10.0001 14.6667L14.6667 1.3334L1.3334 6.00006L7.3334 8.66672Z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
